import { useTranslation } from 'react-i18next';
import { navShoppingGuideUrl } from '@/mocks/articles';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center md:items-start gap-2">
            <a href="/" className="text-lg font-heading font-bold text-foreground-900">
              Kakobuy <span className="text-primary-500">Spreadsheet</span> Polska
            </a>
            <p className="text-xs text-foreground-500 max-w-md text-center md:text-left">
              {t('footer.disclaimer')}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a href="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
              {t('footer.homeLink')}
            </a>
            <a href={navShoppingGuideUrl} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
              {t('nav.shoppingGuide')}
            </a>
            <a href="/artykul/kakobuy-spreadsheet-poradnik" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
              {t('footer.articleLink')}
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/70 text-center">
          <p className="text-xs text-foreground-400">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}